import { render, staticRenderFns } from "./votingUsersList.vue?vue&type=template&id=63a6c36e&"
import script from "./votingUsersList.vue?vue&type=script&lang=js&"
export * from "./votingUsersList.vue?vue&type=script&lang=js&"
import style0 from "./votingUsersList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports